import { render } from "./MainLayout.vue?vue&type=template&id=b20f4ace&scoped=true"
const script = {}

import "./MainLayout.vue?vue&type=style&index=0&id=b20f4ace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20f4ace"]])

export default __exports__